import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "@/context/AuthContext";
import { ContentEditor } from "@/components/admin/ContentEditor";
import { AanvragenList } from "@/components/admin/AanvragenList";
import { SettingsTab } from "@/components/admin/SettingsTab";
import { LogOut, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminDashboard() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [tab, setTab] = useState("content");
  const [content, setContent] = useState(null);

  const loadContent = () =>
    axios.get(`${API}/content`).then((res) => setContent(res.data.data)).catch(() => {});

  useEffect(() => {
    loadContent();
  }, []);

  const handleLogout = async () => {
    await logout();
    navigate("/admin/login");
  };

  return (
    <div className="min-h-screen bg-[#FBF9F5]" data-testid="admin-dashboard">
      <header className="sticky top-0 z-40 bg-[#2B231D] border-b border-[#3E322A]">
        <div className="max-w-5xl mx-auto px-6 h-16 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img src="/assets/logo.jpg" alt="De Houtregisseur logo" className="w-9 h-9 rounded-lg object-cover border border-[#3E322A]" />
            <div>
              <span className="block text-sm font-bold text-white font-display">DE HOUTREGISSEUR</span>
              <span className="block text-[10px] text-[#A89C8F]">Beheer · {user?.email}</span>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <a href="/" data-testid="admin-bekijk-site" className="text-xs text-[#D8CFC4] hover:text-white transition-colors">
              Bekijk website
            </a>
            <button
              onClick={handleLogout}
              data-testid="admin-logout-button"
              className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#E6AF68] text-[#1C1612] text-xs font-semibold hover:bg-[#F0C287] transition-colors"
            >
              <LogOut size={13} />
              Uitloggen
            </button>
          </div>
        </div>
      </header>

      <div className="max-w-5xl mx-auto px-6 py-10">
        <div className="flex gap-2 mb-8">
          <button
            data-testid="tab-content"
            onClick={() => setTab("content")}
            className={`px-5 py-2.5 rounded-full text-sm font-medium transition-colors ${
              tab === "content" ? "bg-[#2B231D] text-[#F9F6F0]" : "bg-white text-[#594E44] border border-[#EAE3DA] hover:border-[#9C6D3B]"
            }`}
          >
            Teksten & Foto's
          </button>
          <button
            data-testid="tab-aanvragen"
            onClick={() => setTab("aanvragen")}
            className={`px-5 py-2.5 rounded-full text-sm font-medium transition-colors ${
              tab === "aanvragen" ? "bg-[#2B231D] text-[#F9F6F0]" : "bg-white text-[#594E44] border border-[#EAE3DA] hover:border-[#9C6D3B]"
            }`}
          >
            Aanvragen
          </button>
          <button
            data-testid="tab-instellingen"
            onClick={() => setTab("instellingen")}
            className={`px-5 py-2.5 rounded-full text-sm font-medium transition-colors ${
              tab === "instellingen" ? "bg-[#2B231D] text-[#F9F6F0]" : "bg-white text-[#594E44] border border-[#EAE3DA] hover:border-[#9C6D3B]"
            }`}
          >
            Instellingen
          </button>
        </div>

        {tab === "content" ? (
          content ? (
            <ContentEditor content={content} onSaved={loadContent} />
          ) : (
            <p className="text-sm text-[#8C7A6B] inline-flex items-center gap-2">
              <Loader2 size={14} className="animate-spin" /> Content laden...
            </p>
          )
        ) : tab === "aanvragen" ? (
          <AanvragenList />
        ) : (
          <SettingsTab />
        )}
      </div>
    </div>
  );
}
